import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Step {
    key: string;
    label: string;
}

interface Props {
    steps: Step[];
    currentStep: number;
}

export default function StepIndicator({ steps, currentStep }: Props) {
    const { t } = useTranslation();

    return (
        <div className="w-full mb-6">
            <div className="flex items-center justify-between">
                {steps.map((step, index) => {
                    const stepNumber = index + 1;
                    const isCompleted = stepNumber < currentStep;
                    const isCurrent = stepNumber === currentStep;

                    return (
                        <div key={step.key} className="flex items-center flex-1 last:flex-none">
                            <div className="flex flex-col items-center gap-1.5">
                                <div
                                    className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-300 ${
                                        isCompleted
                                            ? "bg-theme-700 text-white"
                                            : isCurrent
                                              ? "bg-theme-700 text-white ring-4 ring-theme-100"
                                              : "bg-gray-200 text-gray-500"
                                    }`}
                                >
                                    {isCompleted ? (
                                        <Check className="w-4 h-4" />
                                    ) : (
                                        stepNumber
                                    )}
                                </div>
                                <span
                                    className={`text-[10px] font-medium text-center leading-tight max-w-[60px] hidden sm:block ${
                                        isCurrent
                                            ? "text-theme-700"
                                            : isCompleted
                                              ? "text-theme-600"
                                              : "text-gray-400"
                                    }`}
                                >
                                    {t(step.label)}
                                </span>
                            </div>
                            {index < steps.length - 1 && (
                                <div
                                    className={`flex-1 h-0.5 mx-2 transition-all duration-300 ${
                                        stepNumber < currentStep
                                            ? "bg-theme-700"
                                            : "bg-gray-200"
                                    }`}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
